var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInclusaodossie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71094 1.94238H17.4795C18.0136 1.94238 18.4712 2.13236 18.8516 2.5127C19.2317 2.89292 19.4218 3.34993 19.4219 3.88379V13.5947C19.4219 14.1288 19.2319 14.5865 18.8516 14.9668C18.4712 15.3471 18.0136 15.5371 17.4795 15.5371H1.94238C1.40852 15.5371 0.951526 15.3469 0.571289 14.9668C0.190951 14.5865 0 14.1288 0 13.5947V1.94238C0 1.40829 0.190951 0.950651 0.571289 0.570312C0.951564 0.190132 1.40843 2.31726e-05 1.94238 0H7.76855L9.71094 1.94238ZM1.94238 13.5947H17.4795V3.88379H8.91016L6.96777 1.94238H1.94238V13.5947Z",
    fill: "#865829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusaodossie);
export default __webpack_public_path__ + "static/media/inclusaodossie.ca48634e653cc1f6abae0cee0759c637.svg";
export { ForwardRef as ReactComponent };